/**
 * Initiales de repli quand un compte n'a pas d'avatar.
 *
 * Une initiale par mot, deux au plus : « harper.nelson » donne « HN », pas
 * « HA ». Les identifiants d'ici sont composés (point, tiret, espace), donc
 * couper les deux premiers caractères produirait presque toujours du bruit.
 *
 * Vit dans `libs/` et non à côté d'un composant : trois écrans s'en servent
 * désormais — le pied de la barre latérale, le tableau de bord et la file de
 * modération.
 */
export function initials(value: string): string {
  const words = value.split(/[\s._-]+/).filter(Boolean);

  if (words.length === 0) return "?";

  return words
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();
}
